module.exports = __webpack_public_path__ + "static/flute_cn-b0a7dbc2cd3a939558cc389a90ddfed6.pdf";